var map = {
	"./blood_products.png": 15596,
	"./blood_products_light.png": 20421,
	"./daily_routine_care.png": 95401,
	"./daily_routine_care_light.png": 89548,
	"./eye_care.png": 5990,
	"./eye_care_light.png": 79943,
	"./feeding_tube.png": 14194,
	"./feeding_tube_light.png": 70387,
	"./grbs.png": 59173,
	"./iv_fluids.png": 44688,
	"./iv_fluids_light.png": 16953,
	"./nebulization.png": 10159,
	"./nebulization_light.png": 9194,
	"./nurse.png": 22492,
	"./open_wound_care.png": 71103,
	"./open_wound_care_light.png": 46234,
	"./ostomy_care.png": 24710,
	"./ostomy_care_light.png": 20359,
	"./parental_nutrition.png": 54405,
	"./parental_nutrition_light.png": 6840,
	"./pressure_sore.png": 59338,
	"./pressure_sore_care.png": 53988,
	"./pressure_sore_care_light.png": 31549,
	"./pressure_sore_light.png": 80075,
	"./preventive_care.png": 67863,
	"./preventive_care_light.png": 85618,
	"./respiratory_care.png": 75063,
	"./respiratory_care_light.png": 34834,
	"./sc.png": 84537,
	"./specialist_consultation.png": 70310,
	"./specialist_consultation_light.png": 52263,
	"./urinary_catheter_care.png": 10134,
	"./urinary_catheter_care_light.png": 51927,
	"./vital.png": 48461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62144;